// services/operation/scale/scaleMakeService.ts

import apiClient from "../../../api/apiClient";

export const getScaleMakesApi = async (
  search: string,
  page: number,
  tenantId: string
) => {
  const res = await apiClient.get("/operation/scale-makes", {
    params: {
      Search: search,
      PageNumber: page,
      PageSize: 10,
      TenantId: tenantId,
    },
  });

  return res.data;
};